/**
 * Laenge, gegen die Textfelder validiert werden: ohne Rand-Leerzeichen und mit
 * jeder Folge von Leerraum als genau einem Zeichen. Sonst laesst sich eine
 * Mindestlaenge sowohl mit Leerzeichen am Rand als auch mit langen
 * Leerzeichen-Ketten zwischen den Buchstaben umgehen.
 */
export function normalizeWhitespace(value: string | null | undefined): string {
  return (value ?? '').replace(/\s+/g, ' ').trim();
}

export function normalizedLength(value: string | null | undefined): number {
  return normalizeWhitespace(value).length;
}
